/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Dlh_LinuxInputs */

const en_wc_dlh_linux = /** @type {(inputs: Wc_Dlh_LinuxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AppImage, Flatpak, .deb, .rpm and tarballs for x86_64, ARM64 and RISC-V.`)
};

/**
* | output |
* | --- |
* | "AppImage, Flatpak, .deb, .rpm and tarballs for x86_64, ARM64 and RISC-V." |
*
* @param {Wc_Dlh_LinuxInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_dlh_linux = /** @type {((inputs?: Wc_Dlh_LinuxInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Dlh_LinuxInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_dlh_linux(inputs)
});
export { wc_dlh_linux as "wc.dlh.linux" }